import type { IconName } from "@similarweb/icons";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { ContactSource } from "app/pages/sales-intelligence/modules/ai-agent/types/meeting";

const SOURCE_CONFIG: Record<ContactSource, { icon: IconName; labelKey: string }> = {
    [ContactSource.Salesforce]: {
        icon: "salesforce",
        labelKey: "si.pages.ai_agent.form.keyAttendees.source.salesforce",
    },
    [ContactSource.Hubspot]: { icon: "hubspot", labelKey: "si.pages.ai_agent.form.keyAttendees.source.hubspot" },
    [ContactSource.Dynamics]: { icon: "dynamics", labelKey: "si.pages.ai_agent.form.keyAttendees.source.dynamis" },
    [ContactSource.Similarweb]: {
        icon: "similar-icon",
        labelKey: "si.pages.ai_agent.form.keyAttendees.source.similarweb",
    },
};

const getContactSourceIconColor = (isDisabled: boolean, source: ContactSource): string | undefined => {
    if (isDisabled) {
        return colorsPalettes.carbon[200];
    }
    return source === ContactSource.Similarweb ? undefined : colorsPalettes.carbon[300];
};

type Props = {
    source: ContactSource;
    isDisabled: boolean;
    isTooltipEnabled: boolean;
    onMouseEnter: () => void;
    onMouseLeave: () => void;
};

export const ContactSourceBadge = ({ source, isDisabled, isTooltipEnabled, onMouseEnter, onMouseLeave }: Props) => {
    const label = translate(SOURCE_CONFIG[source].labelKey);

    return (
        <Tooltip
            enabled={isTooltipEnabled}
            content={label}
            placement="top"
        >
            <Flex
                alignItems="center"
                justifyContent="center"
                width="18px"
                height="18px"
                borderRadius="50%"
                background={colorsPalettes.sky[100]}
                aria-label={label}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
            >
                <SWReactIcons
                    iconName={SOURCE_CONFIG[source].icon}
                    iconColor={getContactSourceIconColor(isDisabled, source)}
                    size="11px"
                />
            </Flex>
        </Tooltip>
    );
};
